<div class="pad-30">
  <h2><b>Select Drivers</b></h2>
  <div class="row">
    <!-- Table to handle the operators view-->
    <div class="column twelve none md-block">
      <table class="table table-striped fill lg-large">
        <thead>
          <tr>
            <th scope="col">Driver</th>
            <th scope="col">Status</th>
            <th scope="col">Mobile Phone Number</th>
            <!-- Empty head to accomodate for the save/cancel button spacing-->
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          @for (operator of operatorsData | keyvalue; track operator) {
            <tr>
              <td>
                {{ operator.value.fullName }}
              </td>
              <td>
                <!-- editOperatorsData is an object which stores the values of items in edit mode, so if an item is not in edit mode show the status and edit link-->
                @if (!editOperatorsData[operator.key]) {
                  <div>
                    {{ operator.value.status | kydStatusPipe }}
                    @if (isPhhEligible && operator?.value?.status !== 'Enrolled') {
                      <a (click)="operatorEdit(operator.key)">
                        <i>(edit)</i>
                      </a>
                    }
                  </div>
                }
                <!-- Show status without edit button if in editPhone mode-->
                @if (editOperatorsData[operator.key]) {
                  <div>
                    @if (editOperatorsData[operator.key].isEditPhone) {
                      <span>{{ operator.value.status | kydStatusPipe }}</span>
                    }
                  </div>
                }
                <!-- editOperatorsData is an object which stores the values of items in edit mode, so if an item is in edit mode show the dropdown to choose the status-->
                @if (!!editOperatorsData[operator.key]) {
                  <div>
                    @if (!editOperatorsData[operator.key].isEditPhone) {
                      <div>
                        <div class="form-control-container">
                          <div class="input-group">
                            <div class="input">
                              <select
                                (change)="operatorStatusEdit(operator.key, $event.target.value)"
                                class="icon fill"
                              >
                                @for (
                                  statusValue of operator.value.status
                                    | kydOperatorOptionStatusDisplayPipe;
                                  track statusValue
                                ) {
                                  <option [value]="statusValue | kydOperatorOptionStatusValuePipe">
                                    {{ statusValue }}
                                  </option>
                                }
                              </select>
                              <span class="icon-chevron-down"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </td>
              <td>
                @if (operator.value.status === 'Enrolled' && !editOperatorsData[operator.key]) {
                  <span>
                    {{ operator.value.phoneNumber | prettyPhoneNumber }}
                  </span>
                }
                @if (
                  !!editOperatorsData[operator.key] &&
                  editOperatorsData[operator.key].status == 'Enrolled'
                ) {
                  <div>
                    <div class="form-control-container">
                      <div class="input-group">
                        <div class="input">
                          <input
                            (actualvalue)="operatorPhoneNumberUpdate(operator.key, $event)"
                            [value]="operator.value.phoneNumber | prettyPhoneNumber: true"
                            [identifier]="'phone' + operator.key"
                            id="{{ 'phone' + operator.key }}"
                            maxlength="12"
                            dsPhoneMaskWithoutForm
                            list="phone-numbers-modal"
                            type="tel"
                            inputmode="tel"
                            placeholder="Smartphone Number"
                          />
                        </div>
                      </div>
                    </div>
                    <datalist id="phone-numbers-modal">
                      @for (phone of phoneNumbers; track phone) {
                        <option [value]="phone">
                          {{ phone }}
                        </option>
                      }
                    </datalist>
                    <p class="error-600-text caption">
                      @if (
                        duplicatePhoneError &&
                        editOperatorsData[operator.key].phoneNumber !== operator.value.phoneNumber
                      ) {
                        <span
                          class="error-600-text caption"
                          dsContent
                          [contentPath]="'kydSmartphonePhh.duplicatePhoneError'"
                        ></span>
                      }
                      @if (phoneLengthError) {
                        <span>Phone number must have 10 digits</span>
                      }
                    </p>
                  </div>
                }
                @if (operator.value.status === 'Enrolled' && !editOperatorsData[operator.key]) {
                  <a (click)="operatorPhoneEdit(operator.key)">
                    <i>(edit)</i>
                  </a>
                }
              </td>
              <td>
                <div class="row pad-vertical-20">
                  @if (!!editOperatorsData[operator.key]) {
                    <div class="column twelve flex items-center">
                      @if (!editOperatorsData[operator.key].isEditPhone) {
                        <button
                          ds-button
                          [disabled]="
                            (editOperatorsData[operator.key].status ===
                              operatorsData[operator.key].status &&
                              editOperatorsData[operator.key].phoneNumber ===
                                operatorsData[operator.key].phoneNumber) ||
                            ((duplicatePhoneError ||
                              phoneLengthError ||
                              !editOperatorsData[operator.key].phoneNumber) &&
                              editOperatorsData[operator.key].status === 'Enrolled')
                          "
                          (click)="saveOperator(operator.key)"
                          type="submit"
                          aria-label="Save"
                        >
                          Save
                        </button>
                      }
                      @if (editOperatorsData[operator.key].isEditPhone) {
                        <button
                          ds-button
                          [disabled]="
                            !editOperatorsData[operator.key].phoneNumber ||
                            editOperatorsData[operator.key].phoneNumber ===
                              operatorsData[operator.key].phoneNumber ||
                            duplicatePhoneError ||
                            phoneLengthError
                          "
                          (click)="saveOperator(operator.key)"
                          type="submit"
                          aria-label="Save"
                        >
                          Save
                        </button>
                      }
                      <a
                        class="caption caption margin-left-8"
                        (click)="operatorReset(operator.key)"
                        [attr.aria-label]="'Cancel'"
                      >
                        Cancel
                      </a>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="column twelve block md-none">
      <ds-table
        [ngClass]="{ 'mobile-only': sidebarPresent }"
        [tableClasses]="'action-row'"
        [rows]="getRows()"
        [columns]="columns"
        headerHeight="60"
      >
      </ds-table>
    </div>

    <div class="md-float-right">
      @if (isPolicyEnrolled && (hasMultipleOperatorsEnrolled || !isPhhEligible) && false) {
        <button
          (click)="unEnrollAllOperatorsEvent.emit()"
          ds-button
          class="-outline-white"
          aria-label="UnEnroll All"
        >
          UnEnroll All
        </button>
      }
      @if (!isPolicyEnrolled) {
        <button
          (click)="enrollAllOperatorsEvent.emit()"
          ds-button
          aria-label="Enroll All"
          [disabled]="!isKydEnrolledAndEligible"
        >
          Enroll All
        </button>
      }
    </div>

    <br />
    <hr />
  </div>

  <ds-kyd-smartphone-unenroll-one-modal
    [isLastOperator]="!hasMultipleOperatorsEnrolled"
    [operatorName]="unEnrollOperatorName"
    [policyState]="policyState"
    (unEnrollOne)="unenrollOne()"
    (closeModal)="closeModal($event)"
  ></ds-kyd-smartphone-unenroll-one-modal>

  <!-- Templates for ds-table-->
  <ng-template #headerCellTpl let-column="column">
    <div class="header-cell table-header-cell-wrapper">
      <span
        [ngClass]="{
          'none lg-block': column?.name && column?.shortName,
          block: column?.name && !column?.shortName
        }"
        >{{ column?.name }}</span
      >
      @if (!!column?.shortName) {
        <span class="block lg-none">{{ column?.shortName }}</span>
      }
    </div>
  </ng-template>

  <ng-template #driverNameCellTpl let-row="row">
    <div class="flex md-block bill-account-cell ds-table-body-cell-header-wrapper">
      <div class="block md-none ds-table-body-cell-header">
        <h3 class="margin-0">
          {{ row.fullName }}
        </h3>
      </div>
      <div class="none md-flex table-body-cell-label-content">
        {{ row.fullName }}
      </div>
    </div>
  </ng-template>

  <ng-template #statusCellTpl let-row="row">
    <!-- editOperatorsData is an object which stores the values of items in edit mode, so if an item is not in edit mode show the status and edit link-->
    @if (!editOperatorsData[row.id]) {
      <div>
        {{ row.status | kydStatusPipe }}
        @if (isPhhEligible) {
          <a (click)="operatorEdit(row.id)"> <i>(edit)</i> </a>
        }
      </div>
    }
    <!-- Show status without edit button if in editPhone mode-->
    @if (editOperatorsData[row.id]) {
      <div>
        @if (editOperatorsData[row.id].isEditPhone) {
          <span>{{ row.status | kydStatusPipe }}</span>
        }
      </div>
    }
    <!-- editOperatorsData is an object which stores the values of items in edit mode, so if an item is in edit mode show the dropdown to choose the status-->
    @if (!!editOperatorsData[row.id]) {
      <div>
        @if (!editOperatorsData[row.id].isEditPhone) {
          <div>
            <div class="form-control-container">
              <div class="input-group">
                <div class="input">
                  <select
                    (change)="operatorStatusEdit(row.id, $event.target.value)"
                    class="icon fill"
                  >
                    @for (
                      statusValue of row.status | kydOperatorOptionStatusDisplayPipe;
                      track statusValue
                    ) {
                      <option [value]="statusValue | kydOperatorOptionStatusValuePipe">
                        {{ statusValue }}
                      </option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                </div>
              </div>
            </div>
            <span class="icon-chevron-down"></span>
          </div>
        }
      </div>
    }
  </ng-template>

  <ng-template #phoneNumberCellTpl let-row="row">
    @if (row.status === 'Enrolled' && !editOperatorsData[row.id]) {
      <div>
        {{ row.phoneNumber | prettyPhoneNumber }}
      </div>
    }
    @if (!!editOperatorsData[row.id] && editOperatorsData[row.id].status == 'Enrolled') {
      <div>
        <div class="form-control-container">
          <div class="input-group">
            <div class="input">
              <input
                (actualvalue)="operatorPhoneNumberUpdate(row.id, $event)"
                [identifier]="'phone' + row.id"
                id="{{ 'phone' + row.id }}"
                [value]="row.phoneNumber | prettyPhoneNumber: true"
                maxlength="12"
                dsPhoneMaskWithoutForm
                list="phone-numbers-modal"
                type="tel"
                inputmode="tel"
                placeholder="Smartphone Number"
              />
            </div>
          </div>
        </div>
        <datalist id="phone-numbers-modal">
          @for (phone of phoneNumbers; track phone) {
            <option [value]="phone">
              {{ phone }}
            </option>
          }
        </datalist>
        <p class="error-600-text caption">
          @if (duplicatePhoneError && editOperatorsData[row.id].phoneNumber !== row.phoneNumber) {
            <span dsContent [contentPath]="'kydSmartphonePhh.duplicatePhoneError'"></span>
          }
          @if (phoneLengthError) {
            <span>Phone number must have 10 digits</span>
          }
        </p>
      </div>
    }
    @if (row.status === 'Enrolled' && !editOperatorsData[row.id]) {
      <a (click)="operatorPhoneEdit(row.id)">
        <i>(edit)</i>
      </a>
    }
  </ng-template>

  <ng-template #actionCellTpl let-row="row">
    <div class="row pad-vertical-20">
      @if (!!editOperatorsData[row.id]) {
        <div class="column twelve flex items-center">
          @if (!editOperatorsData[row.id].isEditPhone) {
            <button
              ds-button
              [disabled]="
                (editOperatorsData[row.id].status === operatorsData[row.id].status &&
                  editOperatorsData[row.id].phoneNumber === operatorsData[row.id].phoneNumber) ||
                ((duplicatePhoneError ||
                  phoneLengthError ||
                  !editOperatorsData[row.id].phoneNumber) &&
                  editOperatorsData[row.id].status === 'Enrolled')
              "
              (click)="saveOperator(row.id)"
              type="submit"
              aria-label="Save"
            >
              Save
            </button>
          }
          @if (editOperatorsData[row.id].isEditPhone) {
            <button
              ds-button
              [disabled]="
                !editOperatorsData[row.id].phoneNumber ||
                editOperatorsData[row.id].phoneNumber === operatorsData[row.id].phoneNumber ||
                duplicatePhoneError ||
                phoneLengthError
              "
              (click)="saveOperator(row.id)"
              type="submit"
              aria-label="Save"
            >
              Save
            </button>
          }
          <a
            class="caption caption margin-left-8"
            (click)="operatorReset(row.id)"
            [attr.aria-label]="'Cancel'"
          >
            Cancel
          </a>
        </div>
      }
    </div>
  </ng-template>
</div>
